import script from "./InvoiceTable.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceTable.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceTable.vue?vue&type=style&index=0&id=281b183e&lang=css"

const __exports__ = script;

export default __exports__